import { PssApiTags, pssApiSlicev1 } from "../../../configs/_pss.apis.v1";
import { assigneePaginationFilterParam } from "../../../types/params";
import {
  AssigneePaginatedResponse,
  AssigneeSearchResponse,
  StatusMessageResponse,
} from "../../../types/responses";

export const pssAssigneeDetailsApiSlice = pssApiSlicev1.injectEndpoints({
  endpoints: (builder) => ({
    apiPssFindIncludeAssigneeDetails: builder.query<
      AssigneePaginatedResponse,
      assigneePaginationFilterParam | undefined
    >({
      query: (filter) => {
        if (!filter) {
          return {
            url: "/aprs/assignees",
            method: "GET",
          };
        }
        return {
          url: "/aprs/assignees",
          params: {
            page: filter.page,
            item: filter.item,
            name: filter.name,
          },
          method: "GET",
        };
      },
      providesTags: [PssApiTags.UsersWithRelation],
    }),
    apiPssFindIncludeGetUserAssignee: builder.query<
      AssigneeSearchResponse,
      assigneePaginationFilterParam | undefined
    >({
      query: (filter) => {
        if (!filter) {
          return {
            url: "/aprs/assignees/user/search-by-name",
            method: "GET",
          };
        }
        return {
          url: "/aprs/assignees/user/search-by-name",
          params: {
            name: filter.name,
          },
          method: "GET",
        };
      },
      providesTags: [PssApiTags.UsersWithRelation],
    }),
    apiPssAddAssigneeDetails: builder.mutation<StatusMessageResponse, FormData>(
      {
        query: (data) => {
          return {
            url: `/aprs/assignees`,
            body: data,
            method: "POST",
          };
        },
        invalidatesTags: [PssApiTags.UsersWithRelation],
      },
    ),

    apiPssDeleteAssigneeDetails: builder.mutation<
      StatusMessageResponse,
      string | undefined
    >({
      query: (id) => {
        return {
          url: `/aprs/assignees/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [PssApiTags.UsersWithRelation],
    }),
  }),
});

export const {
  useApiPssFindIncludeGetUserAssigneeQuery: useApiPssFindIncludeGetUserAssignee,
  useApiPssFindIncludeAssigneeDetailsQuery: useApiPssFindIncludeAssigneeDetails,
  useApiPssAddAssigneeDetailsMutation: useApiPssAddAssigneeDetails,
  useApiPssDeleteAssigneeDetailsMutation: useApiPssDeleteAssigneeDetails,
} = pssAssigneeDetailsApiSlice;
